import type { InlineNodeModel } from "@/models/nodes/InlineNodeModel";

export function checkTextCondition(
  textPattern: string | undefined,
  node: InlineNodeModel | undefined,
  text: string | undefined,
) {
  if (!textPattern) return true;

  if (!text) return false;

  return new RegExp(textPattern, "u").test(text);
}
